// Order status lifecycle — mirrors backend/order_lifecycle.py.
// Frontend uses this ONLY for UX affordances (next-status dropdown,
// valid-transition preview). Backend validation is the source of truth.

export const STATUS_FLOW = [
  "order_placed",
  "confirmed",
  "in_progress",
  "shipped",
  "delivered",
  "collected",
  "quality_testing",
  "collection_complete",
];

export const DELIVERY_QUEUE_STATUSES = [
  "order_placed",
  "confirmed",
  "in_progress",
  "shipped",
];

export const COLLECTION_QUEUE_STATUSES = [
  "delivered",
  "collected",
  "quality_testing",
];

const CANCELLABLE_STATUSES = new Set([
  "order_placed",
  "confirmed",
  "in_progress",
]);

// Target states that require a tracking_number on the transition.
export const TRACKING_REQUIRED_STATES = new Set(["shipped"]);

export function nextStatus(current) {
  const i = STATUS_FLOW.indexOf(current);
  if (i < 0 || i + 1 >= STATUS_FLOW.length) return null;
  return STATUS_FLOW[i + 1];
}

export function validNextOptions(current) {
  const out = [];
  const n = nextStatus(current);
  if (n) out.push(n);
  if (CANCELLABLE_STATUSES.has(current)) out.push("cancelled");
  return out;
}

export const SEVERITY_TONE = {
  minor: "bg-offwhite text-text-secondary border-border-subtle",
  major: "bg-status-limited/15 text-taupe border-status-limited/30",
  total_loss: "bg-status-unavailable/10 text-status-unavailable border-status-unavailable/30",
};

export const DAMAGE_STATUS_TONE = {
  open: "bg-status-progress/15 text-status-progress border-status-progress/30",
  investigating: "bg-status-limited/15 text-taupe border-status-limited/30",
  charged: "bg-status-available/10 text-status-available border-status-available/30",
  resolved: "bg-offwhite text-text-secondary border-border-subtle",
};
